import smoothscroll from 'smoothscroll-polyfill';
import picturefill from 'picturefill';

// AOS
import AOS from 'aos';

const spMenu = document.querySelector('.sp_menu');
const btnClose = document.querySelector('.btn_close');
const globalNav = document.querySelector('.global_nav_inner');
const navLinks = document.querySelectorAll('.global_nav_main a');

spMenu.addEventListener('click', e => {
    globalNav.classList.add('open');
});
btnClose.addEventListener('click', e => {
    globalNav.classList.remove('open');
});

navLinks.forEach((item, i) => {
    item.addEventListener('click', e => {
        if(globalNav.classList.contains('open')){
            globalNav.classList.remove('open');
        }
    })
});





// スムーススクロール
smoothscroll.polyfill();

const trigger = document.querySelectorAll('a[href^="#"]');
trigger.forEach((item, i) => {
    item.addEventListener('click', e => {
        e.preventDefault();
        const hash = e.currentTarget.hash ? e.currentTarget.hash : 'html'
        const target = document.querySelector(hash);
        target.scrollIntoView({
            behavior: "smooth",
            block: "start"
        });
    })
});





// ボタンの切り替え
const bntHover = document.querySelectorAll('.bnt_hover img');
bntHover.forEach((item, i) => {
    item.addEventListener('mouseover', target => {
        const src = target.currentTarget.getAttribute('src');
        target.currentTarget.setAttribute('src', src.replace('_off', '_on'));
    });
    item.addEventListener('mouseout', target => {
        const src = target.currentTarget.getAttribute('src');
        target.currentTarget.setAttribute('src', src.replace('_on', '_off'));
    });
});





// アニメーションの設定
AOS.init({
    delay: 200,
    offset: 200,
    once: true,
    duration: 800,
});